export const DASHBOARD_ROUTES = "/dashboard"